var _defs, _metadata, _rect, _g, _g2, _g3, _path, _path2, _path3, _path4, _circle, _circle2, _ellipse, _line, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2095 2095",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:61.9748}\r\n    .str1 {stroke:black;stroke-width:61.9748}\r\n    .str2 {stroke:black;stroke-width:61.9748;stroke-linecap:round;stroke-linejoin:bevel}\r\n    .fil0 {fill:none}\r\n    .fil5 {fill:black}\r\n    .fil3 {fill:#6F6571}\r\n    .fil1 {fill:#857E87}\r\n    .fil4 {fill:#F2D1A5}\r\n    .fil2 {fill:#FF6600}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 158l1772 0 0 1778 -1772 0 0 -1778z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216 1936c17,-122 25,-242 65,-361 22,-65 70,-120 126,-160 63,-45 159,-68 232,-94 193,-70 638,-70 832,0 73,26 168,49 231,94 56,40 104,95 126,160 40,119 48,239 65,361l-1677 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 158l1772 0 0 1778 -1772 0 0 -1778z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_595333192"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2095,
    height: 2095
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "_595333360"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M208 1985c24,-140 27,-276 73,-410 22,-65 70,-120 126,-160 63,-45 159,-68 232,-94 193,-70 638,-70 832,0 73,26 168,49 231,94 56,40 104,95 126,160 46,134 49,270 73,410l-1693 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id1)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil2 str0",
    x: 800,
    y: 1619,
    width: 508,
    height: 530
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id2)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M208 1985c24,-140 27,-276 73,-410 22,-65 70,-120 126,-160 63,-45 159,-68 232,-94 193,-70 638,-70 832,0 73,26 168,49 231,94 56,40 104,95 126,160 46,134 49,270 73,410l-1693 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil3 str1",
    d: "M685 545c-38,234 18,354 50,488 32,134 28,209 28,262 220,83 356,83 576,0 0,-53 -4,-128 28,-262 32,-134 88,-254 50,-488 -70,-421 -662,-421 -732,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil4 str1",
    d: "M886 598c53,23 105,47 119,74 14,27 -62,86 -132,86 -71,0 -110,-43 -110,-89 0,-45 70,-95 123,-71z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil4 str1",
    d: "M1216 598c-53,23 -105,47 -119,74 -14,27 62,86 132,86 71,0 111,-43 111,-89 0,-45 -71,-95 -124,-71z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 892,
    cy: 653,
    r: 42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1210,
    cy: 653,
    r: 42
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "fil4 str1",
    cx: 1055,
    cy: 971,
    rx: 159,
    ry: 118
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "fil0 str2",
    x1: 1019,
    y1: 962,
    x2: 1097,
    y2: 962
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "173,158 1945,158 1945,1936 173,1936 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriminal);
export default __webpack_public_path__ + "static/media/criminal.1e47c41825c9cbfb3cd6e2b44ac125b9.svg";
export { ForwardRef as ReactComponent };